<div class="h-screen w-full flex overflow-hidden">
  <!-- Left Side - Gradient Background with Speech Bubbles -->
  <div class="hidden lg:flex lg:w-1/2 bg-gradient-to-b from-sky-400 via-sky-300 to-blue-400 relative overflow-hidden">
    <!-- Speech Bubble Graphics -->
    <div class="absolute inset-0 flex items-center justify-center">
      <!-- Large speech bubbles -->
      <div class="absolute top-1/4 left-1/4 w-20 h-16 bg-white bg-opacity-30 rounded-full transform -rotate-12"></div>
      <div class="absolute top-1/3 right-1/3 w-16 h-12 bg-sky-200 bg-opacity-40 rounded-full transform rotate-12"></div>
      <div class="absolute bottom-1/3 left-1/3 w-14 h-10 bg-blue-200 bg-opacity-40 rounded-full transform -rotate-6"></div>
    </div>
    
    <!-- Content -->
    <div class="relative z-10 flex flex-col justify-center items-center text-white p-12">
      <div class="text-center">
        <h1 class="text-5xl font-bold mb-6">Welcome Back</h1>
        <p class="text-xl text-white text-opacity-90 mb-12">Seamlessly connect with your network</p>
        
        <!-- WhatsApp-like icon at bottom -->
        <div class="absolute bottom-12">
          <div class="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
            <svg class="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Side - Login Form -->
  <div class="w-full lg:w-1/2 flex items-center justify-center p-6 bg-white relative overflow-hidden">
    <!-- Geometric Patterns -->
    <div class="absolute top-0 right-0 w-32 h-32 bg-gray-100 bg-opacity-30 rounded-full -mr-16 -mt-16"></div>
    <div class="absolute bottom-0 left-0 w-24 h-24 bg-gray-100 bg-opacity-20 rounded-full -ml-12 -mb-12"></div>
    
      <div class="w-full max-w-md relative z-10">
        <!-- Header with Logo -->
        <div class="mb-6">
        <div class="flex items-center mb-4">
          <a class="logo text-start" href="javascript:void(0)" >
            <img class="img-fluid for-light" src="assets/images/simplygenie_logo_w.png" alt="logo" >
        </a>        
      </div>
      </div>

      <!-- Login Form Card -->
      <div class="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
        <!-- Form Header -->
        <div class="text-center mb-6">
          <h2 class="text-2xl font-bold text-gray-800 mb-2">Sign in to account</h2>
          <p class="text-gray-600 text-sm">Enter your email/mobile & password to login</p>
        </div>
        @if(loginType === 'password') {
          <form [formGroup]="loginForm" class="space-y-4" novalidate (ngSubmit)="userLogin(loginForm)">
               <div>
                <label for="userId" class="block text-sm font-medium text-gray-700 mb-2">
                  Email/Mobile Number
                </label>
                <input pInputText formControlName="userId" id="userId"
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition duration-200 text-gray-700 placeholder-gray-400"
                  placeholder="Email Address/Mobile" />
              </div>
              <div>
                <label for="password" class="block text-sm font-medium text-gray-700 mb-2">
                  Password
                </label>
                <input pInputText formControlName="userPassword" id="userPassword"
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition duration-200 text-gray-700 placeholder-gray-400"
                  placeholder="Password" type="password"
                />
              </div>
               <div class="mb-0 mt-2">
                   <a class="text-blue-600 hover:text-blue-700 text-sm font-medium" href="javascript:void(0)"
                       (click)="changeLoginType('otp')">Login with OTP</a>

                   <div class="text-end mt-3">

                       <button pButton pRipple class="w-full bg-sky-500 text-white py-3 px-4 rounded-lg font-medium hover:bg-sky-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200" 
                               [disabled]="loginForm.invalid"type="submit">Sign in</button>
                   </div>
                   <div class="text-end mt-2">
                       <a class="text-blue-600 hover:text-blue-700 text-sm font-medium" href="javascript:void(0)"
                           [routerLink]="['/auth/forgot-password']">Forgot password?</a>
                   </div>
               </div>
           </form>
          } 
          @if(loginType === 'otp') {
            <form [formGroup]="loginOTPForm" class="space-y-4" novalidate (ngSubmit)="userLoginWithOtp(loginOTPForm)">
                 <div>
                  <label for="userId" class="block text-sm font-medium text-gray-700 mb-2">
                    Email/Mobile Number
                  </label>
                  <input pInputText formControlName="userId" id="userId"
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition duration-200 text-gray-700 placeholder-gray-400"
                    placeholder="Email Address/Mobile" />
                </div>
                <div>
                  <label for="password" class="block text-sm font-medium text-gray-700 mb-2">
                    OTP
                  </label>
                  <p-inputOtp formControlName="userOTP" [integerOnly]="true" [length]="5" 
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition duration-200 text-gray-700 placeholder-gray-400"
                    placeholder="OTP"
                  />
                </div>
                 <div class="mb-0 mt-2">
                     <a class="text-blue-600 hover:text-blue-700 text-sm font-medium" href="javascript:void(0)"
                         (click)="changeLoginType('password')">Login with Password</a>
  
                     <div class="text-end mt-3">
  
                         <button pButton pRipple class="w-full bg-sky-500 text-white py-3 px-4 rounded-lg font-medium hover:bg-sky-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200" 
                                 [disabled]="loginOTPForm.invalid"type="submit">Sign in</button>
                     </div>
                     <div class="text-end mt-2">
                         <a class="text-blue-600 hover:text-blue-700 text-sm font-medium" href="javascript:void(0)"
                             [routerLink]="['/auth/forgot-password']">Forgot password?</a>
                     </div>
                 </div>
             </form>
            } 
      </div>
    </div>
  </div>